import PubSub from "underpub-js";

var ListingFilters = function(options) {

	this.options = {
		$el: false,
		baseClass: 'el-ListingFilters',
	};

	$.extend(true, this.options, options);

};

ListingFilters.prototype.init = function() {

	var self = this;

	const $form = self.options.$el.find(`.${self.options.baseClass}__form`);
	const $stateFilter = $form.find('select[name="states"]');
	const $regionFilter = $form.find('select[name="regions"]');
	const $resetButton = $form.find('button[type="reset"]');
	const molecule = $form.data('mol');

	//Display only the States belonging to currently selected Region
	$regionFilter.on('change', function () {
		const selectedRegion = $(this).val();

		$stateFilter.find('option').each(function () {
			const customProps = $(this).data('custom-properties');
			if (selectedRegion === '' || (customProps && customProps.parent === selectedRegion)) {
				$(this).show();
			} else {
				$(this).hide();
			}
		});
		//silently reset the value of states whenever region change
		$stateFilter.val(''); //this doesn't trigger on change event
		PubSub.publish(`${molecule}:resetFilterValue`, { name: 'states' });
	});


	const originalFormState = $form.serialize();
	toggleResetButton();
	function toggleResetButton() {
		$resetButton.hide();
		let currentFormState = $form.serialize();
		if (currentFormState !== originalFormState) {
			$resetButton.show();
		}
	}


	$form.on("change", function (event) {
		const target = event.target;
		PubSub.publish(`${molecule}:filterChanged`, {
			name: target.name,
			value: target.value,
			type: target.type,
			eventType: event.type
		});
		toggleResetButton();
	});

	$form.on("reset", function (event) {
		PubSub.publish(`${molecule}:filterReset`);
		// reset event in JavaScript fires before the form fields are actually reset
		// requestAnimationFrame waits until the next paint frame
		requestAnimationFrame(toggleResetButton);
	});

};

export default ListingFilters;
